import { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Block, BlockHead, BlockHeadContent, BlockTitle } from "../../components/Component";
import { prescriptionList } from "../../api/TellecallerUser";
import { BASE_URL_IMG } from "../../assets/constants";
import { RUPEES_SYMBOL } from "../../assets/constants";
import { searchMedicine } from "../../api/pahrmacy";
import { toast } from "react-toastify";
import { uploadCart } from "../../api/TellecallerUser";
import { prescriptionStatus } from "../../api/TellecallerUser";
import CancelOrderModal from "../../MyComp/UI/modals/CancelOrderModal";
import { FormGroup, Label, Input } from "reactstrap";

const TelecallerPrescription = () => {
    const [prescriptions, setPrescriptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showInput, setShowInput] = useState(true);
    const [items, setItems] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [searchTexts, setSearchTexts] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedMedicine, setSelectedMedicine] = useState(null);
    const [qty, setQty] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [addedPrescriptionIds, setAddedPrescriptionIds] = useState([]);
    const [activeUserId, setActiveUserId] = useState(null);
    const [selectedImage, setSelectedImage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(false);
    const [showUpdateConfirmModal, setShowUpdateConfirmModal] = useState(false);
    const [updateConfirmItem, setUpdateConfirmItem] = useState(null);
    const [replyMessage, setReplyMessage] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    // ✅ FIXED API CALL
    // const fetchPrescriptions = async () => {
    //     try {
    //         setLoading(true);

    //         const res = await prescriptionList({});
    //         console.log("API 👉", res);

    //         const list = res?.data?.data;

    //         if (Array.isArray(list)) {
    //             setPrescriptions(list);
    //         } else {
    //             setPrescriptions([]);
    //         }
    //     } catch (err) {
    //         console.log("Error:", err);
    //         setPrescriptions([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

  const fetchPrescriptions = async (page = 1) => {
    try {
        setLoading(true);

        const res = await prescriptionList({
            page: page,
            limit: itemPerPage
        });
        

        const list = res?.data?.data;

        if (Array.isArray(list)) {
            setPrescriptions(list);
            // ✅ Try different field names
            const pages = res?.data?.totalPages || res?.data?.total_pages || res?.data?.pages || res?.data?.pageCount || 1;
            setTotalPages(pages);
        } else {
            setPrescriptions([]);
            setTotalPages(1);
        }
    } catch (err) {
        console.log("Error:", err);
        setPrescriptions([]);
        setTotalPages(1);
    } finally {
        setLoading(false);
    }
};

    // useEffect(() => {
    //     fetchPrescriptions();
    // }, []);

    useEffect(() => {
        fetchPrescriptions(currentPage);
    }, [currentPage, itemPerPage]);

    // ✅ View Prescription
    // const handleViewPrescription = (file) => {
    //     if (!file) return;

    //     const fullUrl = `${BASE_URL_IMG}${file}`;
    //     window.open(fullUrl, "_blank");
    // };

    // ✅ Handle Search Medicine

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleSearch = (value) => {
        console.log("[TelecallerPrescription] Search input:", value);
        setSearchTexts(value);

        if (selectedMedicine && value !== selectedMedicine.name) {
            setSelectedMedicine(null);
            setQty("");
        }

        if (!value || value.length < 2) {
            setSearchResults([]); // reset
            return;
        }

        searchMedicine({
            search: value,
            page: 1,
            limit: 10,
        })
            .then((res) => {
                if (res?.data?.status) {
                    setSearchResults(res?.data?.data || []);
                } else {
                    setSearchResults([]); // fallback
                }
                console.log(res, "search results");
            })
            .catch((err) => {
                console.log(err);
                setSearchResults([]); // fallback
            });
    };

    // ✅ Handle Select Medicine
    const handleSelectMedicine = (medicine) => {
        console.log("[TelecallerPrescription] Selected medicine:", medicine);
        setSelectedMedicine(medicine); // store selected
        setSearchTexts(medicine.name); // show selected medicine name in input
        setQty(""); // reset qty once new medicine is selected
        setSearchResults([]); // hide dropdown
    };

    // ✅ Handle Add Medicine
    const handleAddMedicine = () => {
        console.log("[TelecallerPrescription] Add medicine clicked", { selectedMedicine, qty, items });
        if (!selectedMedicine) {
            toast.warning("Please select a medicine before adding.");
            return;
        }

        const quantity = Number(qty);
        if (!quantity || quantity <= 0) {
            toast.warning("Please enter a valid quantity.");
            return;
        }

        const newItem = {
            productId: selectedMedicine.id,
            medicineId: selectedMedicine.id,
            product_name: selectedMedicine.name,
            name: selectedMedicine.name,
            unit_price: selectedMedicine.original_price || 0,
            quantity: quantity,
            total: ((selectedMedicine.original_price || 0) * quantity).toFixed(2),
        };

        setItems((prev) => [...prev, newItem]);

        setIsChanged(true);

        // reset for next entry
        setSearchTexts("");
        setQty("");
        setSelectedMedicine(null);
        setSearchResults([]);
    };

    // ✅ Handle Submit Order (Placeholder - adjust as needed)
    const handleSubmitOrder = async () => {
        if (items.length === 0) {
            toast.warning("Please add at least one medicine");
            return;
        }

        if (!selectedUser) {
            toast.warning("Please select a user first (click View Prescription)");
            return;
        }

        try {
            const userId = selectedUser?.userId || selectedUser?.id;

            if (!userId) {
                toast.error("User ID missing ❌");
                return;
            }

            const payloadItems = items.map((item) => ({
                productId: item.productId,
                quantity: item.quantity,
            }));

            const payload = {
                userId,
                items: payloadItems,
            };

            console.log("📦 Payload:", payload);

            const res = await uploadCart(payload);

            // ✅ MAIN FIX
            if (res?.data?.status) {
                toast.success("Added medicine in cart successfully ✅");

                // ✅ STORE PRESCRIPTION ID
                setAddedPrescriptionIds((prev) => (prev.includes(selectedUser.id) ? prev : [...prev, selectedUser.id]));

                // reset
                setItems([]);
                setSearchTexts("");
                setSelectedMedicine(null);
                setQty("");
                setIsChanged(false);
            } else {
                toast.error(res?.data?.message || "Something went wrong");
            }
        } catch (error) {
            console.log(error);
            toast.error("API failed ❌");
        }
    };

    const isPDF = (filePath) => {
        return filePath?.toLowerCase().endsWith(".pdf");
    };

    const handleViewPrescription = (file, user) => {
        if (!file) return;

        const userId = user?.id || user?.userId;

        setSelectedUser(user);

        // toggle logic (same user click → close)
        if (activeUserId === userId) {
            setActiveUserId(null);
            setSelectedImage("");
        } else {
            setActiveUserId(userId);
            setSelectedImage(`${BASE_URL_IMG}${file}`);
        }
    };
    const toggleCancelOrder = (item) => {
        setShowModal(true);
        setSelectedRow(item);

        console.log(item, "item");
    };

    // ✅ OPEN UPDATE CONFIRMATION MODAL
    const openUpdateConfirmModal = (item) => {
        setUpdateConfirmItem(item);
        setShowUpdateConfirmModal(true);
    };

    const closeUpdateConfirmModal = () => {
        setShowUpdateConfirmModal(false);
        setUpdateConfirmItem(null);
    };

    const updateOrderStatus = async (status) => {
        try {
            if (!updateConfirmItem) return;

            const payload = {
                id: updateConfirmItem.id,
                status,
                userId: updateConfirmItem.userId,
                remark: replyMessage || updateConfirmItem.remark || "",
            };

            console.log("📦 Update Payload:", payload);

            const response = await prescriptionStatus(payload);
            const data = response?.data;

            const success =
                data?.status === true ||
                data?.status === "success" ||
                data?.success === true;

            if (success) {
                // ✅ Better toast message
                const message =
                    status === "approved"
                        ? "Prescription Approved successfully ✅"
                        : "Prescription Rejected successfully ❌";

                toast.success(message);

                // ✅ CLOSE MODAL FIRST
                closeUpdateConfirmModal();

                // ✅ REFRESH DATA (NO reload)
                fetchPrescriptions();

            } else {
                toast.error(data?.message || `Failed to update prescription`);
            }
        } catch (error) {
            console.error("Update Prescription Error:", error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };

    // ✅ APPROVE UPDATE
    const handleApproveUpdate = async () => {
        await updateOrderStatus("approved");
    };

    // ✅ REJECT UPDATE
    const handleRejectUpdate = async () => {
        await updateOrderStatus("rejected");
    };


    return (
        <>
            <Head title="User Prescription" />
            <Content>
                <div className="telecaller-prescription-page">
                    <div className="telecaller-prescription-columns">
                        {/* ✅ LEFT SIDE */}
                        <div className="telecaller-prescription-main">
                            <BlockHead size="sm">
                                <BlockHeadContent>
                                    <BlockTitle tag="h3">User Prescription</BlockTitle>
                                </BlockHeadContent>
                            </BlockHead>

                            <div className="card card-bordered">
                                <div className="card-inner-group">
                                    <div className="card-inner">
                                        <h6 className="title">Medicine Prescription</h6>
                                    </div>

                                    {loading ? (
                                        <div className="card-inner">
                                            <Skeleton height={40} className="mb-2" />
                                            <Skeleton height={40} className="mb-2" />
                                            <Skeleton height={40} />
                                        </div>
                                    ) : prescriptions.length === 0 ? (
                                        <div className="card-inner text-center text-muted">No prescriptions found</div>
                                    ) : (
                                        prescriptions.map((item, index) => (
                                            <div key={item.id || index}>
                                                <div className="card-inner card-inner-md">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <div className="lead-text text-primary">{item.userName}</div>
                                                            <div className="sub-text">{item.mobile}</div>
                                                            <div className="sub-text">{item.status}</div>
                                                            <div className="sub-text">{item.remark}</div>
                                                        </div>

                                                        <div className="d-flex flex-column align-items-end">
                                                            {/* Buttons Row */}
                                                            <div className="d-flex gap-2 w-100 justify-content-end">

                                                                {/* ✅ Update Button → only for pending */}
                                                                {item.status?.toLowerCase() === "pending" && (
                                                                    <Button
                                                                        className="flex-fill"
                                                                        style={{ height: "30px" }}
                                                                        color="primary"
                                                                        size="sm"
                                                                        onClick={() => openUpdateConfirmModal(item)}
                                                                    >
                                                                        Update Status
                                                                    </Button>
                                                                )}

                                                                {/* ✅ View Button → for pending + approved */}
                                                                {(item.status?.toLowerCase() === "pending" ||
                                                                    item.status?.toLowerCase() === "approved") && (
                                                                        <Button
                                                                            className="flex-fill"
                                                                            color={activeUserId === item.id ? "primary" : "primary"}
                                                                            size="sm"
                                                                            onClick={() => handleViewPrescription(item.files, item)}
                                                                            style={{ height: "30px" }}
                                                                        >
                                                                            {activeUserId === item.id ? "✓ Viewed" : "View Prescription"}
                                                                        </Button>
                                                                    )}

                                                            </div>

                                                            {/* Prescription Preview */}
                                                            {activeUserId === item.id && (
                                                                <div
                                                                    style={{
                                                                        marginTop: "25px",
                                                                        padding: "12px",
                                                                        border: "2px solid black",
                                                                        borderRadius: "6px",
                                                                        backgroundColor: "#f8f9fa",
                                                                        width: "100%",
                                                                    }}
                                                                >
                                                                    {isPDF(selectedImage) ? (
                                                                        <embed
                                                                            src={selectedImage}
                                                                            type="application/pdf"
                                                                            width="100%"
                                                                            height="300px"
                                                                            style={{
                                                                                borderRadius: "4px",
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src={selectedImage}
                                                                            alt="Prescription"
                                                                            onClick={() => window.open(selectedImage, "_blank")}
                                                                            style={{
                                                                                width: "100%",
                                                                                maxHeight: "300px",
                                                                                objectFit: "contain",
                                                                                borderRadius: "4px",
                                                                                border: "1px solid #ddd",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* Medicine Status */}
                                                            {addedPrescriptionIds.includes(item.id) && (
                                                                <small
                                                                    style={{
                                                                        color: "red",
                                                                        marginTop: "4px",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                >
                                                                    ✓ Added Medicine
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 📄 Image Box Below Prescription */}
                                                {/* {activeUserId === item.id && selectedImage && (
                                                <div className="telecaller-prescription-image-box">
                                                    {isPDF(selectedImage) ? (
                                                        <embed
                                                            src={selectedImage}
                                                            type="application/pdf"
                                                            width="100%"
                                                            height="400px"
                                                            style={{
                                                                borderRadius: "4px",
                                                                border: "1px solid #ddd",
                                                            }}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={selectedImage}
                                                            alt="Prescription"
                                                            onClick={() => window.open(selectedImage, "_blank")}
                                                            className="telecaller-prescription-preview"
                                                        />
                                                    )}
                                                </div>
                                            )} */}
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            {/* ✅ PAGINATION */}
                            {!loading && totalPages > 1 && (
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <Pagination className="justify-content-center">
                                            <PaginationItem disabled={currentPage === 1}>
                                                <PaginationLink
                                                    previous
                                                    onClick={() => paginate(currentPage - 1)}
                                                />
                                            </PaginationItem>

                                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                                <PaginationItem active={page === currentPage} key={page}>
                                                    <PaginationLink onClick={() => paginate(page)}>
                                                        {page}
                                                    </PaginationLink>
                                                </PaginationItem>
                                            ))}

                                            <PaginationItem disabled={currentPage === totalPages}>
                                                <PaginationLink
                                                    next
                                                    onClick={() => paginate(currentPage + 1)}
                                                />
                                            </PaginationItem>
                                        </Pagination>
                                    </div>
                                </div>
                            )}
                        </div>
                    {/* ✅ RIGHT SIDE - Medicine Search */}
                    <div className="telecaller-prescription-side">
                        {/* 🔥 TOP BAR */}
                        <div className="telecaller-prescription-search-row">
                            {/* 🔍 Search */}
                            <div className="search-input">
                                {showInput && (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="Search medicine..."
                                            value={searchTexts}
                                            onChange={(e) => handleSearch(e.target.value)}
                                            className="telecaller-input"
                                            style={{ marginTop: "34px" }}
                                        />

                                        {searchResults?.length > 0 && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "40px",
                                                    width: "100%",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    maxHeight: "150px",
                                                    overflowY: "auto",
                                                    background: "#fff",
                                                    zIndex: 1000,
                                                }}
                                            >
                                                {searchResults.map((item) => (
                                                    <div
                                                        key={item.id}
                                                        style={{
                                                            padding: "6px",
                                                            cursor: "pointer",
                                                            borderBottom: "1px solid #eee",
                                                        }}
                                                        onClick={() => handleSelectMedicine(item)}
                                                    >
                                                        {item.name}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            {/* Qty */}
                            <div className="qty-input">
                                {selectedMedicine && (
                                    <input
                                        type="number"
                                        min="1"
                                        placeholder="Qty"
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                        className="telecaller-input"
                                    />
                                )}
                            </div>

                            {/* Add Button */}
                            <Button
                                color="primary"
                                className="telecaller-add-button"
                                onClick={handleAddMedicine}
                                disabled={!selectedMedicine || !qty}
                            >
                                Add
                            </Button>
                        </div>

                        {/* 🧾 Items List */}
                        {items.length > 0 && (
                            <div className="telecaller-added-items">
                                <strong>Added Medicines:</strong>

                                {items.map((item, idx) => (
                                    <div key={`${item.id}-${idx}`} className="d-flex justify-content-between align-items-center mt-2">
                                        <div>
                                            <div>{item.name}</div>
                                            <small className="text-muted">
                                                Price: {RUPEES_SYMBOL}
                                                {item.unit_price}
                                            </small>
                                        </div>

                                        <div>Qty: {item.quantity}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {/* Update Button */}
                        {items.length > 0 && (
                            <div className="telecaller-submit-row">
                                <Button
                                    className="bg-primary text-light"
                                    style={{
                                        height: "36px",
                                        whiteSpace: "nowrap",
                                    }}
                                    onClick={handleSubmitOrder}
                                >
                                    Add To Cart
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Content >
            <CancelOrderModal
                isOpen={showModal}
                toggle={() => setShowModal(false)}
                // onConfirm={handleCancelOrder}
                item={selectedRow}
            />

    {/* ✅ UPDATE ORDER CONFIRMATION MODAL */ }
    <Modal isOpen={showUpdateConfirmModal} toggle={closeUpdateConfirmModal} centered>
        <ModalHeader toggle={closeUpdateConfirmModal}>
            Confirm Status Update
        </ModalHeader>
        <ModalBody>
            <p className="text-center">
                <strong>Are you sure you want to update the status of this prescription?</strong>
            </p>
            {/* {updateConfirmItem && (
                    <div className="mt-3">
                      <p><strong>Order ID:</strong> {updateConfirmItem.id}</p>
                      <p><strong>Status:</strong> {updateConfirmItem.status}</p>
                      <p><strong>Remark:</strong> {updateConfirmItem.remark || "N/A"}</p>
                    </div>
                  )} */}
            <FormGroup className="mt-3">
                <Label>Reason:</Label>
                <Input
                    type="textarea"
                    rows="4"
                    value={replyMessage}
                    onChange={(e) => setReplyMessage(e.target.value)}
                    placeholder="Enter reason..."
                />
            </FormGroup>
        </ModalBody>
        <ModalFooter>
            <Button color="danger" onClick={handleRejectUpdate}>
                Reject
            </Button>
            <Button color="success" onClick={handleApproveUpdate}>
                Approve
            </Button>
        </ModalFooter>
    </Modal>
        </>
    );
};

export default TelecallerPrescription;
